// extracted by mini-css-extract-plugin
export default {"timeRow":"BookingItem_timeRow__ApPRL","ellipsisText":"BookingItem_ellipsisText__EhK4F","eventWrapper":"BookingItem_eventWrapper__wLQUQ","tag":"BookingItem_tag__yQ46v"};